import { initMonitoringTool } from './datadog';
import { storeUTMparams } from './utm';
import { setBrandPrimaryColorByQuery } from './theme-color';
import { loadCookiebotScript } from './cookiebot';

export function initAppSettings() {
  initMonitoringTool();
  setBrandPrimaryColorByQuery();
  storeUTMparams();
  loadCookiebotScript();

  const _navigator = navigator || window.navigator;
  if (window.location.hash) {
    window.location.hash = '';
  }

  if (
    _navigator.userAgent.indexOf('MSIE ') > 0 ||
    !!_navigator.userAgent.match(/Trident.*rv\:11\./)
  ) {
    document.body.classList.add('ie');
  }
}
